import { translate } from "../../util/translate"

export const appointmentDashboardHeaders = [
  {
    text: translate['appointmentDashboard.label.code'],
    complete: translate['appointmentDashboard.label.code'],
    value: 'code',
    width: '80',
  },
  {
    text: translate['appointmentDashboard.label.realtyCode'],
    complete: translate['appointmentDashboard.label.realtyCodeComp'],
    value: 'realty_codes',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.date'],
    complete: translate['appointmentDashboard.label.date'],
    value: 'date',
    width: '100',
  },
  {
    text: translate['appointmentDashboard.label.host'],
    complete: translate['appointmentDashboard.label.hostComp'],
    value: 'host_name',
    width: '200',
  },
  {
    text: translate['appointmentDashboard.label.status'],
    complete: translate['appointmentDashboard.label.status'],
    value: 'status',
    width: '120',
  },
  {
    text: translate['appointmentDashboard.label.tags'],
    complete: translate['appointmentDashboard.label.tags'],
    value: 'tags',
    width: 'auto',
  },
  {
    text: translate['appointmentDashboard.label.type'],
    complete: translate['appointmentDashboard.label.typeComp'],
    value: 'type',
    width: '200',
  },
  {
    text: translate['appointmentDashboard.label.city'],
    complete: translate['appointmentDashboard.label.city'],
    value: 'city_names',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.firstAppointmentDate'],
    complete: translate['appointmentDashboard.label.firstAppointmentDateComp'],
    value: 'first_appointment_date',
    width: '110',
  },
  {
    text: translate['appointmentDashboard.label.firstAppointmentSLA'],
    complete: translate['appointmentDashboard.label.firstAppointmentSLAComp'],
    value: 'first_appointment_sla',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.firstAcceptanceSLA'],
    complete: translate['appointmentDashboard.label.firstAcceptanceSLAComp'],
    value: 'first_acceptance_sla',
    width: '110',
  },
  {
    text: translate['appointmentDashboard.label.deliverySLA'],
    complete: translate['appointmentDashboard.label.deliverySLAComp'],
    value: 'delivery_sla',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.acceptanceDate'],
    complete: translate['appointmentDashboard.label.acceptanceDateComp'],
    value: 'acceptance_date',
    width: '100',
  },
  {
    text: translate['appointmentDashboard.label.deliveryAndFirstAppointmentDifference'],
    complete: translate['appointmentDashboard.label.deliveryAndFirstAppointmentDifferenceComp'],
    value: 'delivery_and_first_appointment_difference',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.dateCreated'],
    complete: translate['appointmentDashboard.label.dateCreatedComp'],
    value: 'date_created',
    width: '100',
  },
  {
    text: translate['appointmentDashboard.label.cancelDate'],
    complete: translate['appointmentDashboard.label.cancelDateComp'],
    value: 'cancel_date',
    width: '150',
  },
  {
    text: translate['appointmentDashboard.label.cancelReason'],
    complete: translate['appointmentDashboard.label.cancelReasonComp'],
    value: 'cancel_reason',
    width: '300',
  },
  {
    text: translate['appointmentDashboard.label.lastUpdated'],
    complee: translate['appointmentDashboard.label.lastUpdatedComp'],
    value: 'last_updated',
    width: '120',
  },
  {
    text: translate['appointmentDashboard.label.externalCode'],
    complete: translate['appointmentDashboard.label.externalCodeComp'],
    value: 'external_code',
    width: '150',
  },
]
